module.exports = __webpack_public_path__ + "img/san-jose-beach.ccd7dcbb.jpg";